import React from 'react';

const CampanaCta = () => {
  return (
    <section className="campana-cta">
      <div className="campana-cta__container">
        <h2 className="campana-cta__title">Sumá tu alojamiento a la campaña</h2>

        <div className="campana-cta__features">
          <div className="campana-cta__feature">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect width="20" height="14" x="2" y="5" rx="2" />
              <line x1="2" x2="22" y1="10" y2="10" />
            </svg>
            <span>Pago online</span>
          </div>
          <div className="campana-cta__feature">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
            <span>Activación inmediata</span>
          </div>
          <div className="campana-cta__feature">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <span>Cupos limitados</span>
          </div>
        </div>

        <a
          href="https://api.whatsapp.com/send?phone=5492233018749&text=¡Hola%20Alohar!%20Quiero%20participar%20de%20la%20campaña%20de%20visibilidad"
          target="_blank"
          rel="noopener noreferrer"
          className="campana-cta__button"
        >
          Quiero participar
        </a>
      </div>
    </section>
  );
};

export default CampanaCta;
